var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoriteLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.90617 9.74549L7.44728 14.0114L7.44731 14.0114C7.4916 14.053 7.51374 14.0738 7.53455 14.0896C7.71333 14.2255 7.96073 14.2255 8.13951 14.0896C8.16032 14.0738 8.18247 14.053 8.22677 14.0114L12.7679 9.74549C14.0456 8.54524 14.2007 6.57011 13.1261 5.18508L12.9241 4.92465C11.6386 3.26776 9.05818 3.54563 8.1549 5.43823C8.0273 5.70557 7.64676 5.70557 7.51916 5.43823C6.61587 3.54563 4.03549 3.26776 2.74997 4.92466L2.54792 5.18508C1.47332 6.57012 1.62848 8.54525 2.90617 9.74549Z",
    stroke: "white",
    strokeOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteLight);
export default __webpack_public_path__ + "static/media/Favorite_light.5b152d1d1410b2624aa546369f5de482.svg";
export { ForwardRef as ReactComponent };